import { useFormikContext } from 'formik';
import { NewPersonVM } from 'shell/components/shared/sipo-person-form/new-person';
import { Fragment, memo, useMemo, useState } from 'react';
import { CivilStatusID } from 'shell/constants/civil-status';
import AccordionCivilStatus from './accordion-civil-status';
import Marriage from './marriage';
import Widowhood from './widowhood';
import VoidMarriage from './marriage-void';
import CivilUnion from './civil-union';
import VoidCivilUnion from './civil-union-void';

const CivilStatusComponent = (): React.ReactElement => {
  const formContext = useFormikContext<NewPersonVM>();

  const [hasChangedCivilStatus, setHasChangedCivilStatus] = useState(false);

  const status = useMemo(() => {
    if (hasChangedCivilStatus) {
      setHasChangedCivilStatus(false);
      // reset
      formContext.setValues({
        ...(formContext.values || {}),
        marriage: {
          generality: {
            fiscalCode: '',
            surname: '',
            name: '',
            birthDate: null,
            gender: '',
            isForeign: false,
            italian: {
              location: '',
              province: '',
              municipality: null,
            },
            foreign: undefined,
          },
          eventDate: null,
          isForeign: false,
          italian: {
            location: '',
            province: '',
            municipality: null,
          },
          foreign: {
            municipality: null,
            province: '',
            state: null,
          },
          from: null,
          year: '',
          portion: '',
          range: '',
          documentNumber: '',
          regVol: '',
          documentDate: null,
          municipality: null,
        },
        widowhood: {
          isForeign: false,
          italian: {
            location: '',
            province: '',
            municipality: null,
          },
          foreign: {
            municipality: null,
            province: '',
            state: null,
          },
          documentDate: null,
          year: '',
          portion: '',
          range: '',
          documentNumber: '',
          regVol: '',
          eventDate: null,
          municipality: null,
        },
        voidMarriage: {
          type: '',
          eventDate: null,
          validityDate: null,
          authority: '',
          municipality: null,
          portion: '',
          documentNumber: '',
          regVol: '',
          range: '',
          year: '',
          documentDate: null,
        },
        civilUnion: {
          generality: {
            fiscalCode: '',
            surname: '',
            name: '',
            birthDate: null,
            gender: '',
            isForeign: false,
            italian: {
              location: '',
              province: '',
              municipality: null,
            },
            foreign: {
              municipality: null,
              province: '',
              state: null,
            },
          },
          citizenship: null,
          municipality: null,
          eventDate: null,
          isForeign: false,
          italian: {
            location: '',
            province: '',
            municipality: null,
          },
          foreign: {
            municipality: null,
            province: '',
            state: null,
          },
          from: null,
          year: '',
          portion: '',
          range: '',
          documentNumber: '',
          regVol: '',
          documentDate: null,
        },
        voidCivilUnion: {
          number: undefined,
          eventDate: null,
          validityDate: null,
          authority: '',
          municipality: null,
          year: '',
          portion: '',
          range: '',
          documentNumber: '',
          regVol: '',
          documentDate: null,
        },
      });
    }

    return formContext.values.civilStatus?.status?.toString();
  }, [formContext.values.civilStatus?.status, hasChangedCivilStatus]);

  return (
    <Fragment>
      <AccordionCivilStatus setHasChangedCivilStatus={setHasChangedCivilStatus} />
      {status === CivilStatusID.coniugato ||
      status === CivilStatusID.vedovo ||
      status === CivilStatusID.divorziato ? (
        <Marriage />
      ) : undefined}
      {status === CivilStatusID.vedovo ? <Widowhood /> : undefined}
      {status === CivilStatusID.divorziato ? <VoidMarriage /> : undefined}
      {status === CivilStatusID.unitoCivilmente ||
      status === CivilStatusID.scioglimentoUnitoCivilmente ? (
        <CivilUnion />
      ) : undefined}
      {status === CivilStatusID.scioglimentoUnitoCivilmente ? <VoidCivilUnion /> : undefined}
    </Fragment>
  );
};

CivilStatusComponent.displayName = 'Civil Status step component';

const CivilStatus = memo(CivilStatusComponent);

export default CivilStatus;
